
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import FormInput from "@/components/agent-upload/FormInput";
import { AgentFormData } from "@/models/agent-form";

const DescriptionSection: React.FC = () => {
  const form = useFormContext<AgentFormData>();
  
  return (
    <>
      <FormField
        control={form.control}
        name="fullDescription"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Full Description</FormLabel>
            <FormControl>
              <FormInput
                id="fullDescription"
                name="fullDescription"
                label=""
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder="Provide a detailed description of your agent and its capabilities"
                multiline={true}
                rows={6}
                error={form.formState.errors.fullDescription?.message}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="features"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Features</FormLabel>
            <FormControl>
              <FormInput
                id="features"
                name="features"
                label=""
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder="List features of your agent (one per line)"
                multiline={true}
                rows={4}
                error={form.formState.errors.features?.message}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="useCases"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Use Cases</FormLabel>
            <FormControl>
              <FormInput
                id="useCases"
                name="useCases"
                label=""
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder="List potential use cases for your agent (one per line)"
                multiline={true}
                rows={4}
                error={form.formState.errors.useCases?.message}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="requirements"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Requirements</FormLabel>
            <FormControl>
              <FormInput
                id="requirements"
                name="requirements"
                label=""
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder="List any requirements or dependencies for your agent"
                multiline={true}
                rows={3}
                error={form.formState.errors.requirements?.message}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default DescriptionSection;
